module.exports = __webpack_public_path__ + "static/media/artist.444938d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/artist.png
// module id = 351
// module chunks = 0